export const POSTHOG_API_KEY =
    "phc_iRbaFEZh3cukolxAjli0CMDds0c1BfNJKlbFxd8fT0u";
export const POSTHOG_URL = "https://app.posthog.com";
